@if (products().length > 0) {
  <ui-slider
    [navigation]="navigation() && products().length > 1"
    [autoplay]="autoplay()"
    [duration]="duration()"
    [spaceBetween]="16">
    @for (product of products(); track product) {
      @if (!small()) {
        <ui-product-card
          (addToShoppingListClicked)="addToShoppingList.emit($event)"
          [isPromotion]="highlightedProducts().includes(product)"
          [product]="product"
          [showActions]="true"
          [position]="$index"
          uiSliderSlide
          uiProductImpression
        ></ui-product-card>
      } @else {
        <ui-product-card-small
          [isPromotion]="highlightedProducts().includes(product)"
          [product]="product"
          [position]="$index"
          uiSliderSlide
          uiProductImpression
        ></ui-product-card-small>
      }
    }
  </ui-slider>
}
